import { Component, Input, OnInit } from "@angular/core";
import { UpgradeModalService } from "../../../upgrade-modal/upgrade-modal.service";

@Component({
  selector: "ab-breadcrumbs",
  templateUrl: "./breadcrumbs.component.html",
})
export class BreadcrumbsComponent implements OnInit {
  @Input() public contextHistory: any;
  @Input() public featureEnabled: boolean;

  // Breadcrumbs to display as a placeholder when this feature is disabled.
  private sampleHistory = [
    {
      type: "error",
      target: 'html > body > script[src="https://example.com/app.js"]',
    },
    { type: "xhr", url: "https://api.example.com/things", statusCode: 418 },
    { type: "DOMContentLoaded" },
    { type: "load" },
    { type: "click", target: "html > body > nav > a.username" },
  ];

  constructor(private upgradeModal: UpgradeModalService) {}

  public openUpgradeModal($event: Event) {
    this.upgradeModal.open($event);
  }

  public trackBy(index: number, _item: any) {
    return index;
  }

  public ngOnInit() {
    // Show sample breadcrumbs when the feature is disabled.
    if (!this.featureEnabled) {
      this.contextHistory = this.sampleHistory;
      return;
    }

    if (this.contextHistory) {
      this.contextHistory = this.contextHistory.filter((item: any) => item);
    }
  }
}
